import GatewayDistributionChart from "./charts/gatewayDistributionChart";

export default function GatewayDistribution() {
    return (
        <div className="bg-card rounded-lg flex flex-col gap-y-4 p-6">
            <h1 className="text-white text-md">Gateway Distribution</h1>
            <div className="w-full">
                {/* <div className="flex flex-col gap-y-3">
                    <div className="flex items-center gap-x-2">
                        <div className="w-8 h-6 bg-airtel rounded-md"></div>
                        <p className="text-white text-sm">Airtel Money</p>
                    </div>
                </div> */}
                <GatewayDistributionChart />
            </div>
        </div>
    );
}